/**
 * The page a practice's promotional email links to for unsubscribing. The backend builds each
 * patient's link from the same path (`SendCampaignEmailToLocationHandler`), so the two must change
 * together.
 */
export const EMAIL_PREFERENCES_PATH = "/email-preferences";

/** The link's query parameter carrying the patient's preferences token. */
export const EMAIL_PREFERENCES_TOKEN_PARAM = "token";

/** Whether `pathname` is the email-preferences page, with or without a trailing slash. */
export const isEmailPreferencesPath = (pathname: string): boolean =>
  pathname.replace(/\/+$/, "") === EMAIL_PREFERENCES_PATH;
